import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Button,
} from "@mui/material";

import Sidebar from "../../components/Sidebar";
import {
  DeleteButton,
  EditButton,
  FulfillButton,
  Main,
  RemoveFulfillButton,
  SubTitle,
  Table,
  Tables,
  Title,
} from "./orderlistfloripa";
import {
  Content,
  Filter,
  FilterTitle,
  CloseFilter,
  Indicators,
  FulfillModal,
  CloseFulfillModal,
  FulfillModalTitle,
  FormBox,
  DownloadExcelWrapper,
  Overlay,
} from "../../utils/stylesbase";

import StoreContext from "../../components/Store/Context";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { API_URL } from "../../utils/env";

const convertDate = (date) => {
  date = date.split("/");
  const day = date[0];
  const month = date[1];
  const year = date[2];

  return new Date(`${year}-${month}-${day}`);
};

const convertDateBRtoEN = (date) => {
  date = date.split("/");
  const day = date[0];
  const month = date[1];
  const year = date[2];

  return `${year}-${month}-${day}`;
};

const OrderListFloripa = () => {
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);

  const {
    sidebarClosed,
    userName,
    userPermissions,
    setSidebarClosed,
    selectedFiltersOrders: selectedFilters,
    setSelectedFiltersOrders: setSelectedFilters,
    ordersIsFiltered,
    setOrdersIsFiltered,
  } = useContext(StoreContext);

  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [activeFilter, setActiveFilter] = useState(false);
  const [filtersOptions, setFiltersOptions] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState(0);
  const [fulfillModalOpened, setFulfillModalOpened] = useState(false);
  const [recordsToFulfill, setRecordsToFulfill] = useState([]);
  const [selectedOrderRef, setSelectedOrderRef] = useState("");
  const [fulfillOption, setFulfillOption] = useState("add");
  const [selectedLines, setSelectedLines] = useState([]);

  const tableRef = useRef(null);

  const [dateFilters, setDateFilters] = useState({
    registeredDateFormated: {
      start: "0001-01-02",
      end: "9999-12-08",
    },
  });

  const columnsNames = [
    {
      code: "orderRef",
      name: "#",
    },
    {
      code: "orderPlataform",
      name: "Plataform",
    },
    {
      code: "name",
      name: "Name",
    },
    {
      code: "date",
      name: "Tickets Date",
    },
    {
      code: "ticket",
      name: "Tickets",
    },
    {
      code: "currency",
      name: "Currency",
    },
    {
      code: "price",
      name: "Price",
    },
    {
      code: "pax",
      name: "Pax",
    },
    {
      code: "contact",
      name: "Contact",
    },
    {
      code: "discount",
      name: "Discount",
    },
    {
      code: "country",
      name: "Country",
    },
    {
      code: "fulfilled",
      name: "Fulfilled",
    },
    {
      code: "fulfillDateFormated",
      name: "Fulfill Date",
    },
    {
      code: "registeredDateFormated",
      name: "Date of Registration",
    },
    {
      code: "createdBy",
      name: "Created By",
    },
    {
      code: "lastEditBy",
      name: "Last Edit By",
    },
  ];

  const deleteTicket = useCallback(
    async (ticketId, orderRef) => {
      if ([5].indexOf(userPermissions) !== -1) return;
      MySwal.fire({
        title: `Are you sure you want to cancel the ticket on booking ${orderRef}`,
        showCancelButton: true,
        confirmButtonText: "Yes",
        input: "text",
        inputLabel: "Cancel Reason",
        inputPlaceholder: "Cancel Reason",
        inputAttributes: {
          name: "cancelReason",
        },
      }).then(({ ...params }) => {
        if (params.isConfirmed) {
          const body = {
            cancelReason: params.value,
            createdBy: userName,
            lastEditBy: userName,
          };
          fetch(`${API_URL}floripa/tickets/delete.php?id=${ticketId}`, {
            method: "POST",
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((response) =>
              Swal.fire("Ticket cancelled successfully!!", "", "success").then(
                () => {
                  return navigate("/order-list-canceled-floripa");
                }
              )
            );
        }
      });
    },
    [userName, userPermissions]
  );

  const fulfillTicket = useCallback(
    async (orderRef, option) => {
      if ([5].indexOf(userPermissions) !== -1) return;
      fetch(`${API_URL}floripa/fulfill/get-all.php?order-ref=${orderRef}`)
        .then((response) => response.json())
        .then((response) => {
          setFulfillOption(option);
          setRecordsToFulfill(response);
          setSelectedOrderRef(orderRef);
          setReset(Math.random());
          setFulfillModalOpened(true);
        });
    },
    [userName, userPermissions]
  );

  const editOrder = useCallback((orderId) => {
    navigate(`/order-update-floripa?id=${orderId}`);
  }, []);

  const openFilter = useCallback(
    (filter) => {
      setSearch("");
      setActiveFilter(filter);
      let options = [];
      tickets.forEach((ticket) => {
        if (options.indexOf(ticket[filter]) === -1) {
          let valid = true;
          selectedFilters.forEach((selectedFilter) => {
            if (
              selectedFilter.selecteds.indexOf(
                ticket[selectedFilter.attributeName]
              ) === -1 &&
              selectedFilter.attributeName !== filter
            )
              valid = false;
          });
          if (valid) options.push(ticket[filter]);
        }
      });
      options = options.sort((a, b) => (a > b ? 1 : -1));
      setFiltersOptions(options);
    },
    [tickets, setActiveFilter, selectedFilters]
  );

  const searchFilters = useCallback(
    (e) => {
      const search = e.target.value;
      const filter = activeFilter;
      setSearch(search);
      let options = [];
      tickets.forEach((ticket) => {
        if (options.indexOf(ticket[filter]) === -1)
          options.push(ticket[filter]);
      });
      options = options.filter((a) =>
        a ? a.toLowerCase().includes(search.toLowerCase()) : false
      );
      options = options.sort((a, b) => (a > b ? 1 : -1));
      setFiltersOptions(options);
    },
    [activeFilter, tickets]
  );

  const closeFilter = useCallback(() => {
    setActiveFilter(false);
  }, [setActiveFilter]);

  const changeFilter = useCallback(
    (e, attribute, option) => {
      let newFilters = selectedFilters;
      if (e.target.checked) {
        if (newFilters.find((item) => item.attributeName === attribute)) {
          newFilters
            .find((item) => item.attributeName === attribute)
            .selecteds.push(option);
        } else {
          newFilters.push({ attributeName: attribute, selecteds: [option] });
        }
      } else {
        newFilters
          .find((item) => item.attributeName === attribute)
          .selecteds.splice(
            newFilters
              .find((item) => item.attributeName === attribute)
              .selecteds.indexOf(option),
            1
          );
      }

      setSelectedFilters(newFilters);
      setReset(Math.random());
    },
    [selectedFilters, activeFilter]
  );

  const changeDateFilter = useCallback(
    (e, filter, id) => {
      let newDateFilters = dateFilters;
      newDateFilters[filter][id] = e.target.value;
      setDateFilters(newDateFilters);
      setReset(Math.random());
    },
    [dateFilters]
  );

  const checkFilterIsActive = useCallback(
    (option) => {
      if (
        selectedFilters.find((item) => item.attributeName === activeFilter) &&
        selectedFilters
          .find((item) => item.attributeName === activeFilter)
          .selecteds.indexOf(option) !== -1
      )
        return true;
      else return false;
    },
    [activeFilter, selectedFilters, reset]
  );

  const checkIfColumnIsFiltered = useCallback(
    (column) => {
      let filters = [];

      tickets.forEach((ticket) => {
        if (filters.indexOf(ticket[column]) === -1)
          filters.push(ticket[column]);
      });

      const total = filters.length;

      if (
        !selectedFilters.find((filter) => filter.attributeName === column) ||
        !selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds
      )
        return false;

      return (
        selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds.length !== total
      );
    },
    [selectedFilters, tickets]
  );

  const selectAll = useCallback(() => {
    let newFilters = selectedFilters;

    let filter = newFilters.find(
      (filter) => filter.attributeName === activeFilter
    );

    tickets.forEach((ticket) => {
      if (filter.selecteds.indexOf(ticket[activeFilter]) === -1)
        filter.selecteds.push(ticket[activeFilter]);
    });

    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = filter.selecteds;

    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const clearAll = useCallback(() => {
    let newFilters = selectedFilters;
    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = [];
    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const resetFilters = useCallback(() => {
    //Seleciona todos os filtros possíveis
    let filters = [];

    columnsNames.forEach((attribute) => {
      tickets.forEach((ticket) => {
        if (filters.find((item) => item.attributeName === attribute.code)) {
          if (
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.indexOf(ticket[attribute.code]) === -1
          )
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.push(ticket[attribute.code]);
        } else {
          filters.push({
            attributeName: attribute.code,
            selecteds: [ticket[attribute.code]],
          });
        }
      });
    });
    setSelectedFilters(filters);
  }, [tickets]);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const elements = Array.from(e.target.elements);
      let body = [];
      elements.forEach((el) => {
        if (el.tagName === "INPUT") {
          const type = el.id.split("-")[0].trim();
          const id = el.id.split("-")[1].trim();
          if (el.checked) {
            body.push({
              type,
              id,
            });
          }
        }
      });
      if (fulfillOption === "add") {
        fetch(`${API_URL}floripa/fulfill/fulfill-several.php`, {
          method: "POST",
          body: JSON.stringify({ records: body, lastEditBy: userName }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            } else {
              Swal.fire("Records fulfilled successfully!!", "", "success").then(
                () => {
                  return navigate(0);
                }
              );
            }
          });
      } else if (fulfillOption === "remove") {
        fetch(`${API_URL}floripa/fulfill/unfulfill-several.php`, {
          method: "POST",
          body: JSON.stringify({ records: body, lastEditBy: userName }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            } else {
              Swal.fire(
                "Records fulfill removed successfully!!",
                "",
                "success"
              ).then(() => {
                return navigate(0);
              });
            }
          });
      }
    },
    [fulfillOption]
  );

  const toggleSelectedLine = useCallback(
    (tourId) => {
      let newSelectedLines = selectedLines;
      if (newSelectedLines.indexOf(tourId) === -1)
        newSelectedLines.push(tourId);
      else newSelectedLines.splice(newSelectedLines.indexOf(tourId), 1);
      setSelectedLines(newSelectedLines);
      setReset(Math.random());
    },
    [selectedLines]
  );

  useEffect(() => {
    fetch(`${API_URL}floripa/tickets/list-all.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setTickets(response);
        setFilteredTickets(response);

        if (!ordersIsFiltered) {
          setOrdersIsFiltered(true);
          //Seleciona todos os filtros possíveis
          let filters = [];

          columnsNames.forEach((attribute) => {
            response.forEach((ticket) => {
              if (
                filters.find((item) => item.attributeName === attribute.code)
              ) {
                if (
                  filters
                    .find((item) => item.attributeName === attribute.code)
                    .selecteds.indexOf(ticket[attribute.code]) === -1
                )
                  filters
                    .find((item) => item.attributeName === attribute.code)
                    .selecteds.push(ticket[attribute.code]);
              } else {
                filters.push({
                  attributeName: attribute.code,
                  selecteds: [ticket[attribute.code]],
                });
              }
            });
          });
          setSelectedFilters(filters);
        }

        //Seta a maior e menor data de RegisteredDate
        let registeredDateStart = "";
        let registeredDateEnd = "";
        response.forEach((ticket) => {
          if (registeredDateStart === "") {
            registeredDateStart = ticket.registeredDateFormated;
            registeredDateEnd = ticket.registeredDateFormated;
          } else {
            if (
              convertDate(ticket.registeredDateFormated) <
              convertDate(registeredDateStart)
            )
              registeredDateStart = ticket.registeredDateFormated;
            if (
              convertDate(ticket.registeredDateFormated) >
              convertDate(registeredDateEnd)
            )
              registeredDateEnd = ticket.registeredDateFormated;
          }

          let dates = dateFilters;
          dates.registeredDateFormated.start =
            convertDateBRtoEN(registeredDateStart);
          dates.registeredDateFormated.end =
            convertDateBRtoEN(registeredDateEnd);
        });
      });
  }, [dateFilters]);

  //Atualiza os tickets filtrados
  useEffect(() => {
    const filteredItems = tickets.filter((ticket) => {
      let ok = true;
      selectedFilters.forEach((filter) => {
        if (filter.selecteds.indexOf(ticket[filter.attributeName]) === -1) {
          ok = false;
          return;
        }
      });
      if (
        convertDate(ticket.registeredDateFormated) <
          new Date(dateFilters.registeredDateFormated.start) ||
        convertDate(ticket.registeredDateFormated) >
          new Date(dateFilters.registeredDateFormated.end)
      ) {
        ok = false;
      }

      return ok;
    });
    setFilteredTickets(filteredItems);
  }, [selectedFilters, reset, tickets, dateFilters]);

  useEffect(() => {
    let dollarTotal = 0;
    let realTotal = 0;
    let paxTotal = 0;
    filteredTickets.forEach((ticket) => {
      if (ticket.currency === "$") dollarTotal += parseFloat(ticket.price || 0);
      else if (ticket.currency === "R$")
        realTotal += parseFloat(ticket.price || 0);
      paxTotal += parseInt(ticket.pax || 0);
    });
    setIndicators({
      dollarTotal: dollarTotal,
      realTotal: realTotal,
      paxTotal: paxTotal,
    });
  }, [filteredTickets]);

  useEffect(() => {
    setSidebarClosed(true);
  }, []);

  return (
    <Main>
      <Sidebar />
      <Content sidebarclosed={sidebarClosed.toString()}>
        {[1, 2].indexOf(userPermissions) !== -1 && (
          <Indicators>
            <thead>
              <tr>
                <th>$ Total</th>
                <th>R$ Total</th>
                <th>Pax Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{indicators.dollarTotal}</td>
                <td>{indicators.realTotal}</td>
                <td>{indicators.paxTotal}</td>
              </tr>
            </tbody>
          </Indicators>
        )}
        <SubTitle>Floripa</SubTitle>
        <Title>Order - List</Title>
        <DownloadExcelWrapper>
          <DownloadTableExcel
            filename="Order-List"
            sheet="order-list"
            currentTableRef={tableRef.current}
          >
            <Button variant="outlined" style={{ marginBottom: "20px" }}>
              Export to excel
            </Button>
          </DownloadTableExcel>
          <Button
            variant="outlined"
            style={{ marginBottom: "20px", marginLeft: "20px" }}
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        </DownloadExcelWrapper>
        <Tables>
          <Table ref={tableRef}>
            <thead>
              <tr>
                {columnsNames.map((column) => {
                  return (
                    <th
                      onClick={() => openFilter(column.code)}
                      className={`${
                        checkIfColumnIsFiltered(column.code) ? "active" : ""
                      }`}
                      key={column.code}
                    >
                      {column.name}
                    </th>
                  );
                })}
                <th className="sticky-right"></th>
              </tr>
            </thead>
            <tbody>
              {filteredTickets.map((ticket) => {
                return (
                  <tr
                    key={ticket.ticket_id}
                    className={
                      selectedLines.indexOf(ticket.id) !== -1
                        ? "selected"
                        : ticket.fulfilled === "1"
                        ? "fulfilled"
                        : ""
                    }
                    onClick={() => toggleSelectedLine(ticket.id)}
                  >
                    <td>{ticket.orderRef}</td>
                    <td>{ticket.orderPlataform}</td>
                    <td>{ticket.name}</td>
                    <td>{ticket.date}</td>
                    <td>{ticket.ticket}</td>
                    <td>{ticket.currency}</td>
                    <td>{ticket.price}</td>
                    <td>{ticket.pax}</td>
                    <td>{ticket.contact}</td>
                    <td>{ticket.discount}</td>
                    <td>{ticket.country}</td>
                    <td>
                      {ticket.fulfilled === "1" ? (
                        <CheckBoxIcon value="yes" />
                      ) : (
                        <CheckBoxOutlineBlankIcon value="no" />
                      )}
                    </td>
                    <td>{ticket.fulfillDateFormated}</td>
                    <td>{ticket.registeredDateFormated}</td>
                    <td>{ticket.createdBy}</td>
                    <td>{ticket.lastEditBy}</td>
                    <td className="actions sticky-right">
                      {[1, 4, 5].indexOf(userPermissions) !== -1 && (
                        <Tooltip title="Edit" placement="top">
                          <EditButton
                            onClick={() => editOrder(ticket.order_id)}
                          />
                        </Tooltip>
                      )}
                      {[1, 4, 5].indexOf(userPermissions) !== -1 && (
                        <Tooltip title="Delete" placement="top">
                          <DeleteButton
                            onClick={() =>
                              deleteTicket(ticket.ticket_id, ticket.orderRef)
                            }
                          />
                        </Tooltip>
                      )}
                      {[1, 3, 4, 5].indexOf(userPermissions) !== -1 &&
                        (ticket.fulfilled === "1" ? (
                          <Tooltip title="Remove Fulfill" placement="top">
                            <RemoveFulfillButton
                              onClick={() =>
                                fulfillTicket(ticket.orderRef, "remove")
                              }
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Fulfill" placement="top">
                            <FulfillButton
                              onClick={() =>
                                fulfillTicket(ticket.orderRef, "add")
                              }
                            />
                          </Tooltip>
                        ))}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Tables>
        <Filter opened={(activeFilter !== false).toString()}>
          <FilterTitle>
            Filtering{" "}
            {activeFilter &&
              columnsNames.find((filter) => activeFilter === filter.code).name}
          </FilterTitle>
          <CloseFilter onClick={() => closeFilter()} />
          {activeFilter === "registeredDateFormated" ? (
            <div className="date-filter">
              <TextField
                id={`start-${activeFilter}`}
                label="Start Date"
                variant="outlined"
                name={`start-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.start}
                onChange={(e) => changeDateFilter(e, activeFilter, "start")}
              />
              <TextField
                id={`end-${activeFilter}`}
                label="End Date"
                variant="outlined"
                name={`end-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.end}
                onChange={(e) => changeDateFilter(e, activeFilter, "end")}
              />
            </div>
          ) : (
            <ul status={reset}>
              <div className="filters-actions">
                <span onClick={selectAll}>Select All</span>
                <span onClick={clearAll}>Clear All</span>
              </div>
              <div className="filters-search">
                <TextField
                  id="search"
                  label="Search"
                  variant="outlined"
                  name="search-orders-list"
                  value={search}
                  onChange={searchFilters}
                />
              </div>
              <div className="filters-options">
                {filtersOptions.map((option) => {
                  return (
                    <li key={option}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={option}
                              name={option}
                              onChange={(e) =>
                                changeFilter(e, activeFilter, option)
                              }
                              checked={checkFilterIsActive(option)}
                            />
                          }
                          label={
                            activeFilter === "fulfilled"
                              ? option === "1"
                                ? "Yes"
                                : "No"
                              : option
                          }
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </div>
            </ul>
          )}
        </Filter>
        <Overlay opened={fulfillModalOpened.toString()}>
          <FulfillModal status={reset} opened={fulfillModalOpened.toString()}>
            <FulfillModalTitle>
              Select records to{" "}
              {fulfillOption === "add" ? "fulfill" : "remove fulfill"} on
              order-ref {selectedOrderRef}
            </FulfillModalTitle>
            <CloseFulfillModal onClick={() => setFulfillModalOpened(false)} />
            <FormBox
              component="form"
              noValidate
              autoComplete="off"
              onSubmit={onSubmit}
            >
              {recordsToFulfill.map((record) => (
                <FormGroup key={`${record.id}-${record.type}`}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={`${record.type} - ${record.id}`}
                        name={record.id}
                        record-type={record.type}
                        inputProps={{
                          "record-type": record.type,
                        }}
                      />
                    }
                    label={`${record.type} ${
                      record.date ? `- ${record.date}` : ""
                    } ${record.sector ? `- ${record.sector}` : ""}`}
                  />
                </FormGroup>
              ))}
              <Button variant="outlined" type="submit">
                Save
              </Button>
            </FormBox>
          </FulfillModal>
        </Overlay>
      </Content>
    </Main>
  );
};

export default OrderListFloripa;
